module.exports = __webpack_public_path__ + "static/2018-PLOS-5bcbbfe7182bf17209183d6dbb05a863.pdf";